import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import api from "../../services/api";
import { Toast } from "../../shared/Toast";
import { useNavigate } from "react-router";
import { CreativeContext } from "./CreativeCreation";
import { SlProgressBar } from "@shoelace-style/shoelace/dist/react";

function VideoSkippable({
  company,
  companyName,
  handleshow,
  // advId,
  creative_name,
  creative_type,
  subtype,
  editdata,
  flag,
  handlesubmit,
  createdEdited,
}) {
  const navigate = useNavigate();

  const { preview, setPreview } = useContext(CreativeContext);
  const [progress, setProgress] = useState(0);
  const [vidProgress, setVidProgress] = useState(0);
  const [videourl, setVideourl] = useState("");
  const [video, setVideo] = useState("");
  const [showPre, setShowPre] = useState(false);
  const [showMid, setShowMid] = useState(false);
  const [showEnd, setShowEnd] = useState(false);
  const [inputFields, setInputFields] = useState({
    pre: [],
    mid: [],
    post: [],
  });

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({ mode: "onSubmit" });
  const formData = new FormData();

  const watchPreCheck = watch('pre_check')
  const watchMidCheck = watch('mid_check')
  const watchPostCheck = watch('post_check')

  formData.append("files", video);
  const videoUrl = async () => {
    try {
      let url = await api({
        url: `/upload/brandVideo`,
        method: "POST",
        responseType: "json",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (data) => {
          setVidProgress(Math.round((100 * data.loaded) / data.total));
        },
      });
      if (url.code === 200) {
        setVideourl(url.data.data);
        setPreview({
          ...preview,
          video_urls: url.data.data,
        });
        setValue("videolink", "");
      } else {
        setVidProgress(0);
        setValue("video", "");
        setVideo("");
        Toast("error", url.data.message);
      }
    } catch (error) {
      Toast("error", error);
    }
  };

  useEffect(() => {
    if (video) videoUrl();
  }, [video]);


  useEffect(() => {
    if (flag === "edit") {
      setPreview({
        ...preview,
        sub_type: editdata.sub_type,
        data: editdata.img_urls,
      });
  
      // Set inputFields state properly
      setInputFields({
        pre: editdata.gallery?.pre || [],
        mid: editdata.gallery?.mid || [],
        post: editdata.gallery?.post || []
      });
  
      // Set checkbox and show/hide states based on array lengths
      setValue('pre_check', editdata.gallery?.pre?.length > 0);
      setShowPre(editdata.gallery?.pre?.length > 0);
  
      setValue('mid_check', editdata.gallery?.mid?.length > 0);
      setShowMid(editdata.gallery?.mid?.length > 0);
  
      setValue('post_check', editdata.gallery?.post?.length > 0);
      setShowEnd(editdata.gallery?.post?.length > 0);
    }
  }, [flag, editdata.gallery]);
  
  const videoChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      if (e.target.files[0].size < 26214400) {
        setVideo(e.target.files[0]);
      } else {
        Toast("error", "Video size must be less than 25mb");
        setValue("video", "");
      }
    } else {
      if (flag === "edit") {
        setVideourl(editdata.video_urls);
        setPreview({ ...preview, video_urls: editdata.video_urls });
      } else {
        setVidProgress(0);
        setVideourl("");
        setPreview({ ...preview, video_urls: "" });
      }
    }
  };

  const onSubmit = async (data) => {
    if (flag === "add") {
      handlesubmit(true);
      let obj = {
        company_id: company,
        company_name: companyName,
        creative_name,
        creative_type,
        sub_type: subtype,
        inputFields,
      };
      // if (advId !== "" && creative_name !== "") {
      if (creative_name !== "") {
        try {
          let res = await api({
            url: `/creatives/brandad/video-skippable`,
            method: "POST",
            responseType: "json",
            data: obj,
          });
          if (res?.code === 200) {
            Toast("success", " Creative Created Successfully  ");
            handleshow(false);
            createdEdited(true);
          } else {
            Toast("error", res.data.message);
          }
        } catch (error) {
          console.error(error);
          if (error.response.status === 401) navigate("/");
        }
      }
    } else if (flag === "edit") {
      let obj = {
        creative_id: editdata.creative_id,
        creative_name: creative_name,
        inputFields,
      };
      try {
        let res = await api({
          url: `/creatives/brandad/edit-video-skippable`,
          method: "POST",
          responseType: "json",
          data: obj,
        });
        if (res?.code === 200) {
          Toast("success", " Creative Edited Successfully");
          handleshow(false);
          createdEdited(true);
        } else {
          Toast("error", res.data.message);
        }
      } catch (error) {
        console.error(error);
        if (error.response.status === 401) navigate("/");
      }
    }
  };

  const handleCheckboxChange = (value, checked) => {
    if (value === "pre") {
      if (checked) {
        setShowPre(true);
        setInputFields({
          ...inputFields,
          pre: [
            {
              video: "",
              impurl1: "",
              impurl2: "",
              click_url: "",
              skip_time: "",
              start_time: "",
              end_time: "",
            },
          ],
        });
      } else {
        setShowPre(false);
        setInputFields({ ...inputFields, pre: [] });
      }
    } else if (value === "mid") {
      if (checked) {
        setShowMid(true);
        setInputFields({
          ...inputFields,
          mid: [
            ...inputFields.mid,
            {
              video: "",
              impurl1: "",
              impurl2: "",
              click_url: "",
              skip_time: "",
              start_time: "",
              end_time: "",
            },
          ],
        });
      } else {
        setShowMid(false);
        setInputFields({ ...inputFields, mid: [] });
      }
    } else {
      if (checked) {
        setShowEnd(true);
        setInputFields({
          ...inputFields,
          post: [
            {
              video: "",
              impurl1: "",
              impurl2: "",
              click_url: "",
              skip_time: "",
              start_time: "",
              end_time: "",
            },
          ],
        });
      } else {
        setShowEnd(false);
        setInputFields({ ...inputFields, post: [] });
      }
    }
  };

  const handlePrevVideo = (type, e) => {
    setInputFields((prevState) => {
      const values = { ...prevState.pre[0] }; // Create a copy of the object
      values[type] = e.target.value;
      return {
        ...prevState,
        pre: [values], // Ensure pre is an array with the updated values object
      };
    });
  };

  const handlePostVideo = (type, e) => {
    setInputFields((prevState) => {
      const values = { ...prevState.post[0] }; // Create a copy of the object
      values[type] = e.target.value;
      return {
        ...prevState,
        post: [values], // Ensure pre is an array with the updated values object
      };
    });
  };

  const handleRemove = (index) => {
    setInputFields((prevState) => {
      const values = [ ...inputFields.mid ]; // Create a copy of the object
      setValue(`video_${index}`, "")
      setValue(`video_${index}_link`, "")
      setValue(`clickurl_${index}`, "")
      setValue(`impurl1${index}`, "")
      setValue(`impurl2${index}`, "")
      setValue(`skip_time_${index}`, "")
      setValue(`start_time_${index}`, "")
      setValue(`end_time_${index}`, "")
      values.splice(index, 1);
      return {
        ...prevState,
        mid: values, // Ensure pre is an array with the updated values object
      };
    });
  };

  const handleClickUrl = (index, event) => {
    setInputFields((prevState) => {
      const values = [ ...prevState.mid ]; // Create a copy of the object
      values[index].click_url = event.target.value;
      return {
        ...prevState,
        mid: values, // Ensure pre is an array with the updated values object
      };
    });
  };

  const handleImpUrl = (index, event) => {
    setInputFields((prevState) => {
      const values = [ ...prevState.mid ]; // Create a copy of the object
      values[index].impurl1 = event.target.value;
      return {
        ...prevState,
        mid: values, // Ensure pre is an array with the updated values object
      };
    });
  };

  const handleImpUrl2 = (index, event) => {
    setInputFields((prevState) => {
      const values = [ ...prevState.mid ]; // Create a copy of the object
      values[index].impurl2 = event.target.value;
      return {
        ...prevState,
        mid: values, // Ensure pre is an array with the updated values object
      };
    });
  };

  const handleEndTime = (index, event) => {
    setInputFields((prevState) => {
      const values = [ ...prevState.mid ]; // Create a copy of the object
      values[index].end_time = event.target.value;
      return {
        ...prevState,
        mid: values, // Ensure pre is an array with the updated values object
      };
    });
  };

  const handleSkipTime = (index, event) => {
    setInputFields((prevState) => {
      const values = [ ...prevState.mid ]; // Create a copy of the object
      values[index].skip_time = event.target.value;
      return {
        ...prevState,
        mid: values, // Ensure pre is an array with the updated values object
      };
    });
  };

  const handleMidVideo = (index, event) => {
    setInputFields((prevState) => {
      const values = [ ...prevState.mid ]; // Create a copy of the object
      console.log(values)
      values[index].video = event.target.value;
      return {
        ...prevState,
        mid: values, // Ensure pre is an array with the updated values object
      };
    });
  };

  const hadnleStartTime = (index, event) => {
    setInputFields((prevState) => {
      const values = [ ...prevState.mid ]; // Create a copy of the object
      values[index].start_time = event.target.value;
      return {
        ...prevState,
        mid: values, // Ensure pre is an array with the updated values object
      };
    });
  };

  return (
    <>
      <div className="row">
        <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="checkbox"
              id="pre"
              value="pre"
              checked={watchPreCheck}
              {
                ...register('pre_check', {

                  required:!(watchPreCheck || watchMidCheck || watchPostCheck),
                  onChange : (e) => handleCheckboxChange(e.target.value, e.target.checked)
                })
              }
            />
            <label class="form-check-label" for="inlineCheckbox1">
              Pre
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="checkbox"
              id="mid"
              value="mid"
              checked={watchMidCheck}
              {
                ...register('mid_check', {

                  required:!(watchPreCheck || watchMidCheck || watchPostCheck),
                  onChange : (e) => handleCheckboxChange(e.target.value, e.target.checked)
                })
              }
            />
            <label class="form-check-label" for="inlineCheckbox2">
              Mid
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="checkbox"
              id="post"
              value="post"
              checked={watchPostCheck}
              {
                ...register('post_check', {

                  required:!(watchPreCheck || watchMidCheck || watchPostCheck),
                  onChange : (e) => handleCheckboxChange(e.target.value, e.target.checked)
                })
              }
            />
            <label class="form-check-label" for="inlineCheckbox3">
              Post
            </label>

          </div>
          {
            (errors.pre_check || errors.mid_check || errors.post_check) && <p className="text-red-600">Please choose atleast one from above options</p>
          }
          {showPre && (
            <div className="row">
              <section className="col-12">
                <h6>Pre Video</h6>
                <div className="mb-3">
                  <label className="form-label">Upload video</label>
                  <br />
                  <span>
                    (Video duration must be below 1-min and size must be less
                    than 25mb )
                  </span>
                  <input
                    className="form-control mb-2"
                    type="file"
                    id="formFile"
                    name="files"
                    {...register("pre_video", {
                      required:
                          !inputFields.pre[0]?.video
                          ? true
                          : false,
                      onChange: (e) => videoChange(e),
                    })}
                  />
                  {errors.pre_video && (
                    <p className="text-red-600">Video is mandatory</p>
                  )}
                  {vidProgress > 0 && vidProgress < 100 ? (
                    <SlProgressBar value={vidProgress}>
                      {vidProgress}%
                    </SlProgressBar>
                  ) : inputFields?.pre[0]?.video ? (
                    <span>{`${inputFields.pre[0]?.video}`}</span>
                  ) : (
                    flag === "edit" && (
                      <span>{`${inputFields?.pre[0]?.video}`}</span>
                    )
                  )}
                </div>
                <div className="mb-3">
                  <label className="form-label">Video URL</label>
                  <input
                    className="form-control"
                    type="text"
                    {...register("pre_videolink", {
                      required: false,
                      onChange: (e) => handlePrevVideo("video", e),
                      pattern: {
                        value:
                          /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/,
                        message: "Enter a Valid .mp4 URL",
                      },
                    })}
                  />

                  {errors.pre_videolink && (
                    <p className="text-red-600">
                      {errors.pre_videolink.message}
                    </p>
                  )}
                </div>

                <div className="row mb-3">
                  <div className="col">
                    <label className="form-label">
                      Click URL / Mobile Number
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      defaultValue={
                        flag === "edit" ? inputFields.pre[0]?.click_url : null
                      }
                      name="clickurl"
                      {...register("clickurl", {
                        required: false,
                        onChange: (e) => handlePrevVideo("click_url", e),
                        pattern: {
                          value:
                            /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)|^(0\d{10}|[6-9]\d{9})$/,
                          message: "Enter a Valid URL or Mobile Number",
                        },
                      })}
                    />
                    {errors.clickurl && (
                      <p className="text-red-600">{errors.clickurl.message}</p>
                    )}
                  </div>
                  <div className="col">
                    <label className="form-label">
                      Impression URL - Primary
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      defaultValue={
                        flag === "edit" && inputFields.pre[0]?.impurl1
                          ? inputFields.pre[0]?.impurl1
                          : null
                      }
                      {...register("impurl", {
                        required: false,
                        onChange: (e) => handlePrevVideo("impurl1", e),
                        pattern: {
                          value:
                            /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
                          message: "Enter a Valid URL",
                        },
                      })}
                    />
                    {errors.impurl && (
                      <p className="text-red-600">{errors.impurl.message}</p>
                    )}
                  </div>
                  <div className="col">
                    <label className="form-label">
                      Impression URL - Secondary
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      defaultValue={
                        flag === "edit" && inputFields.pre[0]?.impurl2
                          ? inputFields.pre[0]?.impurl2
                          : null
                      }
                      {...register("impurl1", {
                        required: false,
                        onChange: (e) => handlePrevVideo("impurl2", e),
                        pattern: {
                          value:
                            /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
                          message: "Enter a Valid URL",
                        },
                      })}
                    />
                    {errors.impurl1 && (
                      <p className="text-red-600">{errors.impurl1.message}</p>
                    )}
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col">
                    <label className="form-label">Skip time</label>
                    <input
                      className="form-control"
                      type="number"
                      defaultValue={
                        flag === "edit" && inputFields.pre[0].skip_time
                          ? inputFields.pre[0]?.skip_time
                          : null
                      }
                      {...register("pre_skip_time", {
                        required: true,
                        onChange: (e) => handlePrevVideo("skip_time", e),
                      })}
                    ></input>
                    {errors.pre_skip_time && (
                      <p className="text-red-600">{"Skip time is required!"}</p>
                    )}
                  </div>
                  <div className="col">
                    <label className="form-label">Start time</label>
                    <input
                      className="form-control"
                      defaultValue={
                        flag === "edit" && inputFields.pre[0].start_time
                          ? inputFields.pre[0]?.start_time
                          : null
                      }
                      type="number"
                      {...register("pre_start_time", {
                        required: true,
                        onChange: (e) => handlePrevVideo("start_time", e),
                      })}
                    ></input>
                    {errors.pre_start_time && (
                      <p className="text-red-600">
                        {"Start time is required!"}
                      </p>
                    )}
                  </div>
                  <div className="col">
                    <label className="form-label">End time</label>
                    <input
                      className="form-control"
                      defaultValue={
                        flag === "edit" && inputFields.pre[0].end_time
                          ? inputFields.pre[0]?.end_time
                          : null
                      }
                      type="number"
                      {...register("pre_end_time", {
                        required: true,
                        onChange: (e) => handlePrevVideo("end_time", e),
                      })}
                    ></input>
                    {errors.pre_end_time && (
                      <p className="text-red-600">{"End time is required!"}</p>
                    )}
                  </div>
                </div>
              </section>
            </div>
          )}
          {showMid && (
            <>
              <h6>Mid Video</h6>
              <div className="d-flex justify-end my-2">
                <button
                  type="button"
                  name="add"
                  className="btn btn-primary"
                  onClick={() => handleCheckboxChange("mid", true)}
                >
                  Add
                </button>
              </div>
              {inputFields.mid.map((inputField, index) => (
                <div key={index} className="border p-2 mb-2">
                  <div className="mb-3">
                    <label className="form-label">Upload video</label>
                    <br />
                    <span>
                      (Video duration must be below 1-min and size must be less
                      than 25mb )
                    </span>
                    <input
                      className="form-control mb-2"
                      type="file"
                      id="formFile"
                      name="files"
                      {...register(`video_${index}`, {
                        required:
                           !inputFields.mid[index]?.video
                            ? true
                            : false,
                        onChange: (e) => videoChange(e),
                      })}
                    />
                    {errors[`video_${index}`] && (
                      <p className="text-red-600">Video is mandatory</p>
                    )}
                    {vidProgress > 0 && vidProgress < 100 ? (
                      <SlProgressBar value={vidProgress}>
                        {vidProgress}%
                      </SlProgressBar>
                    ) : inputFields.mid[index]?.video  ? (
                      <span>{`${inputFields.mid[index]?.video}`}</span>
                    ) : (
                      flag === "edit" && (
                        <span>{`${inputFields.mid[index]?.video}`}</span>
                      )
                    )}
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Video URL</label>
                    <input
                      className="form-control"
                      type="text"
                      {...register(`video_${index}_link`, {
                        required: false,
                        onChange: (e) => handleMidVideo(index, e),
                        pattern: {
                          value:
                            /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/,
                          message: "Enter a Valid .mp4 URL",
                        },
                      })}
                    />

                    {errors[`video_${index}_link`] && (
                      <p className="text-red-600">
                        {errors[`video_${index}_link`].message}
                      </p>
                    )}
                  </div>
                  <div className="row mb-3 align-items-end">
                    <div className="col">
                      <label className="form-label">
                        Click URL / Mobile Number
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        defaultValue={
                          flag === "edit"
                            ? inputFields.mid[index]?.click_url
                            : ""
                        }
                        {...register(`click_url${index}`, {
                          required: false,
                          onChange: (e) => handleClickUrl(index, e),
                          pattern: {
                            value:
                              /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)|^(0\d{10}|[6-9]\d{9})$/,
                            message: "Enter a Valid URL or Mobile Number",
                          },
                        })}
                      />
                      {errors[`click_url${index}`] && (
                        <p style={{ color: "red" }}>
                          {errors[`click_url${index}`].message}
                        </p>
                      )}
                    </div>
                    <div className="col">
                      <label className="form-label">
                        Impression URL - Primary
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        defaultValue={
                          flag === "edit" ? inputFields.mid[index]?.impurl1 : ""
                        }
                        {...register(`impression_url${index}`, {
                          required: false,
                          onChange: (e) => handleImpUrl(index, e),
                          pattern: {
                            value:
                              /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
                            message: "Enter a Valid URL",
                          },
                        })}
                      />
                      {errors[`impression_url${index}`] && (
                        <p style={{ color: "red" }}>
                          {errors[`impression_url${index}`].message}
                        </p>
                      )}
                    </div>
                    <div className="col">
                      <label className="form-label">
                        Impression URL - Secondary
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        defaultValue={
                          flag === "edit"
                            ? inputFields.mid[index]?.impurl2
                            : ""
                        }
                        {...register(`impression_url_secondary${index}`, {
                          required: false,
                          onChange: (e) => handleImpUrl2(index, e),
                          pattern: {
                            value:
                              /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
                            message: "Enter a Valid URL",
                          },
                        })}
                      />
                      {errors[`impression_url_secondary${index}`] && (
                        <p style={{ color: "red" }}>
                          {errors[`impression_url_secondary${index}`].message}
                        </p>
                      )}
                    </div>
                    <div className="row mb-3">
                      <div className="col">
                        <label className="form-label">Skip time</label>
                        <input
                          className="form-control"
                          defaultValue={
                            flag === "edit" && inputFields?.mid[index]?.skip_time
                              ? inputFields?.mid[index]?.skip_time
                              : null
                          }
                          {...register(`skip_time_${index}`, {
                            required: true,
                            onChange: (e) => handleSkipTime(index, e),
                          })}
                          type="number"
                        ></input>
                        {errors[`skip_time_${index}`] && (
                          <p style={{ color: "red" }}>
                            {"Skip time is required!"}
                          </p>
                        )}
                      </div>
                      <div className="col">
                        <label className="form-label">Start time</label>
                        <input
                          className="form-control"
                          defaultValue={
                            flag === "edit" && inputFields?.mid[index]?.start_time
                              ? inputFields?.mid[index]?.start_time
                              : null
                          }
                          {...register(`start_time_${index}`, {
                            required: true,
                            onChange: (e) => hadnleStartTime(index, e),
                          })}
                          type="number"
                        ></input>
                        {errors[`start_time_${index}`] && (
                          <p style={{ color: "red" }}>
                            {"Start time is required!"}
                          </p>
                        )}
                      </div>
                      <div className="col">
                        <label className="form-label">End time</label>
                        <input
                          className="form-control"
                          defaultValue={
                            flag === "edit" && inputFields?.mid[index]?.skip_time
                              ? inputFields?.mid[index]?.skip_time
                              : null
                          }
                          {...register(`end_time_${index}`, {
                            required: true,
                            onChange: (e) => handleEndTime(index, e),
                          })}
                          type="number"
                        ></input>
                        {errors[`end_time_${index}`] && (
                          <p style={{ color: "red" }}>
                            {"End time is required!"}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="col">
                      <button
                        type="button"
                        className="btn btn-outline-danger"
                        onClick={() => handleRemove(index)}
                      >
                        {" "}
                        Remove
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </>
          )}
          {showEnd && (
            <div className="row">
              <section className="col-12">
                <h6>Post Video</h6>
                <div className="mb-3">
                  <label className="form-label">Upload video</label>
                  <br />
                  <span>
                    (Video duration must be below 1-min and size must be less
                    than 25mb )
                  </span>
                  <input
                    className="form-control mb-2"
                    type="file"
                    id="formFile"
                    name="files"
                    {...register("video_post", {
                      required:
                           !inputFields.post[0]?.video
                          ? true
                          : false,
                      onChange: (e) => videoChange(e),
                    })}
                  />
                  {errors.video_post && (
                    <p className="text-red-600">Video is mandatory</p>
                  )}
                  {vidProgress > 0 && vidProgress < 100 ? (
                    <SlProgressBar value={vidProgress}>
                      {vidProgress}%
                    </SlProgressBar>
                  ) : inputFields.post[0]?.video !== "" ? (
                    <span>{`${inputFields.post[0]?.video}`}</span>
                  ) : (
                    flag === "edit" && (
                      <span>{`${inputFields.post[0]?.video}`}</span>
                    )
                  )}
                </div>
                <div className="mb-3">
                  <label className="form-label">Video URL</label>
                  <input
                    className="form-control"
                    type="text"
                    {...register("post_videolink", {
                      required: false,
                      onChange: (e) => handlePostVideo("video", e),
                      pattern: {
                        value:
                          /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/,
                        message: "Enter a Valid .mp4 URL",
                      },
                    })}
                  />

                  {errors.post_videolink && (
                    <p className="text-red-600">
                      {errors.post_videolink.message}
                    </p>
                  )}
                </div>
                <div className="row mb-3">
                  <div className="col">
                    <label className="form-label">
                      Click URL / Mobile Number
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      defaultValue={
                        flag === "edit" ? inputFields?.post[0]?.click_url : null
                      }
                      name="clickurl"
                      {...register("clickurl_post", {
                        required: false,
                        onChange: (e) => handlePostVideo("click_url", e),
                        pattern: {
                          value:
                            /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)|^(0\d{10}|[6-9]\d{9})$/,
                          message: "Enter a Valid URL or Mobile Number",
                        },
                      })}
                    />
                    {errors.clickurl_post && (
                      <p className="text-red-600">{errors.clickurl.message}</p>
                    )}
                  </div>
                  <div className="col">
                    <label className="form-label">
                      Impression URL - Primary
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      defaultValue={
                        flag === "edit" && inputFields?.post[0]?.imp_url1
                          ? inputFields?.post[0]?.imp_url1
                          : null
                      }
                      {...register("impurl_post", {
                        required: false,
                        onChange: (e) => handlePostVideo("impurl1", e),
                        pattern: {
                          value:
                            /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
                          message: "Enter a Valid URL",
                        },
                      })}
                    />
                    {errors.impurl_post && (
                      <p className="text-red-600">
                        {errors.impurl_post.message}
                      </p>
                    )}
                  </div>
                  <div className="col">
                    <label className="form-label">
                      Impression URL - Secondary
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      defaultValue={
                        flag === "edit" && inputFields?.post[0]?.imp_url2
                          ? inputFields?.post[0]?.imp_url2
                          : null
                      }
                      {...register("impurl1_post", {
                        required: false,
                        onChange: (e) => handlePostVideo("impurl2", e),
                        pattern: {
                          value:
                            /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
                          message: "Enter a Valid URL",
                        },
                      })}
                    />
                    {errors.impurl1_post && (
                      <p className="text-red-600">
                        {errors.impurl1_post.message}
                      </p>
                    )}
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col">
                    <label className="form-label">Skip time</label>
                    <input
                      className="form-control"
                      type="number"
                      defaultValue={
                        flag === "edit" && inputFields?.post[0]?.skip_time
                          ? inputFields?.post[0]?.skip_time
                          : null
                      }
                      {...register("skip_time_post", {
                        required: true,
                        min: 1,
                        onChange: (e) => handlePostVideo("skip_time", e),
                      })}
                    ></input>
                    {errors.skip_time_post && (
                      <p className="text-red-600">{"Skip time is required!"}</p>
                    )}
                  </div>
                  <div className="col">
                    <label className="form-label">Start time</label>
                    <input
                      className="form-control"
                      type="number"
                      defaultValue={
                        flag === "edit" && inputFields?.post[0]?.start_time
                          ? inputFields?.post[0]?.start_time
                          : null
                      }
                      {...register("start_time_post", {
                        required: true,
                        min: 1,
                        onChange: (e) => handlePostVideo("start_time", e),
                      })}
                    ></input>
                    {errors.start_time_post && (
                      <p className="text-red-600">
                        {"Start time is required!"}
                      </p>
                    )}
                  </div>
                  <div className="col">
                    <label className="form-label">End time</label>
                    <input
                      className="form-control"
                      type="number"
                      defaultValue={
                        flag === "edit" && inputFields?.post[0]?.end_time
                          ? inputFields?.post[0]?.end_time
                          : null
                      }
                      {...register("end_time_post", {
                        required: true,
                        min: 1,
                        onChange: (e) => handlePostVideo("end_time", e),
                      })}
                    ></input>
                    {errors.end_time_post && (
                      <p className="text-red-600">{"End time is required"}</p>
                    )}
                  </div>
                </div>
              </section>
            </div>
          )}
          <div className="my-3 text-end">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={progress > 0 && progress < 100 ? true : false}
            >
              Save Creative
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default VideoSkippable;
